import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { Button } from "@grandvisionhq/common";
import { Types } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { storesLocatorResultEvent } from "../../../../../../data-layer/data-layer/actions.js";
import { useBookAppointmentUrl } from "../../../../../../hooks/hooks/use-book-appointment-url.js";
import { useStoreFinderContext } from "../../../../../../context/StoreFinder/context/StoreFinder/context.js";
import { areServicesAvailable } from "../../../../../../utils/utils/store-utils.js";
const BookAppointmentButtonContainer = ({
  store,
  view,
  isPreferredStore
}) => {
  const { getLabel } = useIntl();
  const { stores, urls } = useStoreFinderContext();
  const { globalStoreId } = store;
  const bookAppointmentUrl = useBookAppointmentUrl(urls?.bookAppointment, store);
  const showBookAppointmentCTA = areServicesAvailable(store, [
    Types.ServicesNotAvailable.APPOINTMENTS
  ]);
  const onStoresLocatorResultEvent = React.useCallback(
    ({
      store: store2,
      preferredStore,
      interaction,
      searchPosition,
      searchResults
    }) => {
      const dataLayerEvent = storesLocatorResultEvent({
        interaction,
        store: store2,
        preferredStore,
        searchPosition,
        searchResults
      });
      DataLayer.pushEvent(dataLayerEvent);
    },
    []
  );
  const onBookAppointmentButtonClickHandler = React.useCallback(() => {
    onStoresLocatorResultEvent(
      view === "list" ? {
        store,
        preferredStore: isPreferredStore,
        interaction: "book appointment click",
        searchPosition: stores.indexOf(store) + 1
      } : {
        store,
        preferredStore: isPreferredStore,
        interaction: "map click - book appointment",
        searchResults: stores.length
      }
    );
    if (bookAppointmentUrl) {
      try {
        window.location.assign(bookAppointmentUrl);
      } catch (error) {
        console.error("Invalid book appointment URL:", error);
      }
    } else {
      console.error("Book appointment URL is undefined or null");
    }
  }, [onStoresLocatorResultEvent, view, store, isPreferredStore, stores, bookAppointmentUrl]);
  if (!showBookAppointmentCTA) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: onBookAppointmentButtonClickHandler,
      variant: "solid",
      size: "small",
      "data-t": `book-appointment-${globalStoreId}`,
      caption: getLabel("stores.page.storeGroup.action.bookAppointment")
    }
  );
};
export {
  BookAppointmentButtonContainer as default
};
//# sourceMappingURL=BookAppointmentButtonContainer.js.map
